
const inquiryType = {
    CheckAvailability: 1,
    RequestPhotos: 2,
    DiscussFinancing: 3,
    AskQuestion: 4,
    VideoChat: 6,
    Offer: 'offer',
    Email: 'email',
    EmailThis: 'emailthis'
};

const bidderStatus = {
    ACTIVE: 'ACTIVE',
    PENDING: 'PENDING',
    DISCARD: 'DISCARD',
    REVOKED: 'REVOKED'
};

const bidCallerCollectionTypes = {
    Choice: 'Choice',
    ChoiceTimesTheMoney: 'ChoiceTimesTheMoney',
    Group: 'Group',
    SplitTimesTheMoney: 'SplitTimesTheMoney',
    TimesTheMoney: 'TimesTheMoney'
};

const hostedStoreGatewayTypes = {
    CurrencyPay: "CurrencyPay",
    FirstData: "First Data",
    GlobalPayments: "Global Payments",
    GlobalPaymentsACH: "Global Payments ACH",
    PayPal: "PayPal",
    Square: "Square",
    Stripe: "Stripe"
};

const categorySpecGroup = {
    Chassis: 28,
    General: 30
};

 const consentCookieNames = {
    CookieBot: 'CookieConsent',
    CookieYes: 'cookieyes-consent',
    OsanoUnencrypted: 'OsanoConsent',
    SandhillsConsent: 'sandhills-consent'
};

const contactType = {
    Retail: 'retail',
    Wholesale: 'wholesale',
    ExclusiveWholesale: 'exclusivewholesale',
    Rental: 'rental'
};

const phoneType = {
    Retail: 'Retail Phone',
    Wholesale: 'WholeSale Phone',
    Rental: 'Rental Phone'
};

const gtmEventType = {
    whatsApp: 'whatsapp',
    messenger: 'messenger',
    call: 'call',
    callRental: 'call-rental',
    callWholesale: 'call-wholesale',
    sms: 'sms',
    vip: 'vip',
    buyNowClick: 'buyNowClick',
    visitHostedSite: 'visitHostedSite',
    calculator: 'calculator',
    highLowAvg: 'highLowAvg',
    printListDetail: 'printListDetail',
    emailThis: 'emailThis',
    controllerButtonClick: 'controllerButtonClick',
    charterHubButtonClick: 'charterHubButtonClick',
    loanApprovalEstimateRegistrationTriggerModal: 'loan-approval-estimate-registration-triggered-modal-popup',
    bidderRegistrationSubmit: 'bidderRegistrationSubmit',
    newRegistration: 'new-registration',
    sellerInfoClick: 'sellerInfoClick',
    sellerAllCategoryClick: 'sellerAllCategoryClick',
    sellerAllListingsClick: 'sellerAllListingsClick',
    googlePlaceSelected: 'google-place-selected',
    MobileShare: 'mobile-share',
    FacebookShare: 'facebook-share',
    TwitterShare: 'twitter-share',
    LinkedInShare: 'linkedin-share',
    MessengerShare: 'messenger-share',
    WhatsAppShare: 'whatsapp-share',
    newListingEmail: 'newListingEmail',
    alertToggleOn: 'alertToggleOn',
    alertToggleOff: 'alertToggleOff',
    imageChange: 'imageChange',
    viewAllImagesClick: 'viewAllImagesClick',
    recommendedListingClick: 'recsys_carousel',
    recommendedListingsAll: 'recsys_carousel_all',
    collapseToggle: 'navBarToggleStatus',
    preBid: 'pre-bid',
    quickBid: 'quick-bid',
    liveBid: 'live-bid',
    auctioneerConsignmentButtonClick: 'auctioneerConsignmentButtonClick',
    viewConsignmentPackageButtonClick: 'viewConsignmentPackageButtonClick',
    viewStandaloneSaleButtonClick: 'viewStandaloneSaleButtonClick', 
    optionsButtonClick: 'optionsButtonClick',
};

const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const monthShortNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];

const dayNames = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];

const dayShortNames = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
];

const queryString = {
    Language: 'lang',
    CountryCode: 'countryCode',
    InventoryType: 'InventoryType',
    Category: 'Category',
    FTCategory: 'FTCategory',
    Manufacturer: 'Manufacturer',
    FTManufacturer: 'FTManufacturer',
    Equipment: 'Equipment',
    EmptyResponse: 'EmptyResponse',
    InfoRequestFailure: 'InfoRequestFailure',
};

const webListingeListingType = {
    forSale: 1,
    forRent: 2,
    dismantled: 4,
    auction: 128,
    auctionResult: 4096
};

const classificationConstants = {
    livestock: '171000',
    haystraw: '170000',
    haystrawCategory: '170001',
    otherstock: '40000',
    land: '172000'
};

const subscriptionChannelType = {
    email: 1,
    textMessage: 2
};

const smsType = {
    listingAlerts: 1,
    auctionAlerts: 2,
    marketing: 3
}

const modalType = {
    qsuModal: 1,
    tsuModal: 2,
    raqModal: 3
};

const homePageCategoryGroup = {
    privateTreaty: 17,
    onlineAuction: 18,
    onSiteAuction: 22
};

const eventCategory = {
    onlineAuction: 7,
    onSiteAuction: 8
};

const userCreationType = {
    notAddedByExternalAuth: 1,
    externalAuthAddedWithPlaceholderData: 2,
    externalAuthAddedWithCleanData: 3,
    minimalAuthAddedWithPlaceholderData: 4
};

const magazineDistributionPublications = [
    'CraneTrader',
    'EquineMarket',
    'ForestryTrader',
    'LivestockMarket',
    'Machinery',
    'NeedTurfEquipment',
    'RentalYard',
    'RVUniverse',
    'TreeTrader',
    'LiftsToday'
];

const listingAlertSpecNamesToCheck = {
    horsepower: 'horsepower',
    hours: 'hours',
    length: 'length',
    mileage: 'mileage,miles',
    validSpecNames: 'horsepower,hours,mileage,miles,engine,width',
    width: 'width',
    engine: 'engine'
};

const loanApprovalFields = [
    {
        Id: 'yearsInBusiness',
        Label: 'Years In Business',
        Options: [
            { Value: '', Label: '' },
            { Value: '1.2', Label: '10+ Years' },
            { Value: '1', Label: '5 to 9 Years' },
            { Value: '0.8', Label: '1 to 4 Years' },
            { Value: '0', Label: 'Less Than 1 Year' }
        ]
    },
    {
        Id: 'creditRange',
        Label: 'Estimated FICO Credit Range',
        Options: [
            { Value: '', Label: '' },
            { Value: '1.25', Label: 'Best' },
            { Value: '1.15', Label: 'Above Average' },
            { Value: '1.13', Label: 'Average' },
            { Value: '0.6', Label: 'Below Average' },
            { Value: '0', Label: 'Challenged' }
        ]
    },
    {
        Id: 'priorMaxLoanSize',
        Label: 'Maximum Prior Equipment Loan Size',
        Options: [
            { Value: '', Label: '' },
            { Value: '0', Label: 'Up to $5,000' },
            { Value: '27000', Label: '$5,000 to $19,999' },
            { Value: '38000', Label: '$20,000 to $34,999' },
            { Value: '58000', Label: '$35,000 to $49,999' },
            { Value: '81000', Label: '$50,000 to $74,999' },
            { Value: '100000', Label: '$75,000 or more' }
        ]
    },
    {
        Id: 'assetClass',
        Label: 'Asset Class',
        Options: [
            { Value: '', Label: '' },
            { Value: '1.3', Label: 'Agriculture' },
            { Value: '0.75', Label: 'Long-Haul Trucking' },
            { Value: '0.92', Label: 'Local Trucking' },
            { Value: '1.30', Label: 'Construction' },
            { Value: '1.1', Label: 'Machine Tools' },
            { Value: '0.8', Label: 'Other' }
        ]
    }
];

const cookieNames = {
    compare: 'compareListing_IDs',
    userSettings: 'UserSettingsCookie',
    cookieBanner: 'GDPRCookieBanner',
    topPopUp: 'Top_PopUp',
    topPopUpAuctionResults: 'Top_PopUp_AuctionResults',
    marketReportEmail: 'MarketReportEmail',
    keywordSearchHistory: 'KeywordSearchHistory',
    DisableGeolocationCookie: 'DisableGeolocationFeatures',
    useBetaSiteCookie: 'SH_UseBetaSite',
    CurrentUserLocationCookie: 'CurrentUserLocation_v2'
};

const bannerAdPositions = {
    Top: 'Top',
    Middle: 'Middle',
    Bottom: 'Bottom',
    AuctionResults: 'AuctionResults',
    TopPopUp: 'TopPopUp',
};

const achFields = {
    ACCOUNT_TYPE: {
        Id: 'accountType',
        Label: 'Account Type',
        Options: [
            { Value: 'checking', Text: 'Checking Account' },
            { Value: 'savings', Text: 'Savings Account' }
        ]
    },
    ACCOUNT_NUMBER: {
        Id: 'accountNumber',
        Label: 'Account Number',
    },
    ROUTING_NUMBER: {
        Id: 'routingNumber',
        Label: 'Routing Number'
    }
};

const sandhillsCookieClassifications = {
    Advertising: 'Advertising',
    Analytics: 'Analytics',
    Customization: 'Customization',
    StrictlyNecessary: 'StrictlyNecessary'
};

const approvalAmountLocalStorageName = 'approvalEstimate';
const popupListDetailLoanApprovalEstimateModal = 'popupListDetailLoanApprovalEstimateModal';
const enableNewRegistrationPopUp = true;
const enableListDetailBanners = true;
const topLevelClassificationsToSkipLowerClassifications = [171254,171301];
const topLevelParentTrailerCategories = [880,881];
const INT32_MAX_VALUE = 2147483647;
const SHORT_MAX_VALUE = 32767;
const webSavedSearchAuthenticatedLimit = 5;
const webSavedSearchNameCharCountLimit = 100;
const customWatchlistLimit = 5;
const homePageCategoryTab = 'trailers';
const maxImageCount = 5;
const daysToSnoozeCurrencyAlerts = 30;
const secondsLeftToAddListingToCountdown = 90;
const secondsInAHour = 3600;

//Any updates to these constants should be reflected in Constants.cs
const listResultsPerPageOptions = [25, 50, 100];
const gridResultsPerPageOptions = [28, 56, 112];
const defaultListPageSize = 25;
const defaultNewListPageSize = 28;

const rentalFacetOptions = [
    'DailyRentalRateMin',
    'WeeklyRentalRateMin',
    'MonthlyRentalRateMin',
    'HourlyRentalRateMin',
    'AcreRentalRateMin',
    'EngineHourlyRentalRateMin',
    'MileageRentalRateMin'
]

const leaseFacetOptions = [ 
    'LeasePrice',
    'LeaseFrequency'
]

const mfaDisplayModes = {
    Unknown: 'unknown',
    BidderRegistration: 'bidder-registration',
    RegistrationForm: 'registration-form'
};

const mfaMethodSource = {
    RegistrationPhone: 'registration-phone',
    RegistrationAltPhone: 'registration-alt-phone',
    RegistrationEmail: 'registration-email',
    Input: 'input'
};

const invalidCurrencyPopUpBaseCatIDs = {
    MachineryAttachment: 81,
    FarmEquipmentAttachment: 22000,
    TruckTrailerAttachment: 35000,
    OtherStock: 40000,
    Livestock: 171000,
    HayStraw: 170000,
    Land: 172000
};

const baseCatBlur = [
    1243, //drones
    13, //aircraft
];

const LinkRelationTypes = {
    noFollow: 'nofollow',
    noReferrer: 'noreferrer'
};

const registrationNotificationTypes = {
    ProxyBidding: 1,
    ActiveBidding: 3,
    FifteenMinutesLeft: 5,
    OutBid: 7,
    AuctionEnded: 9,
    WinningBidShippingQuote: 10,
    AuctionStarts: 11,
    BiddingStarted: 12,
    NumberOfItemsLeft: 13,
    CatalogUploaded: 14
};

const LoginPromptEvents = {
    waitEvent: { Text: "waitEvent", Value: "1" },
    scrollEvent: { Text: "scrollEvent", Value: "2" },
    auctionResultsEvent: { Text: "auctionResultsEvent", Value: "3" },
    detailPageCountEvent: { Text: "detailPageCountEvent", Value: "4" },
    highLowAverageEvent: { Text: "highLowAverageEvent", Value: "5" },
    signInForBestExperience: { Text: "signInModalClosed", Value: "quickSignUpClosed" },
    setAllEvents: { Text: "setAllEvents", Value: "setAllEvents" },
    clearAllEvents: { Text: "clearAllEvents", Value: "clearAllEvents" },
    loginPromptLastClosed: { Text: "loginPromptLastClosed", Value: "loginPromptLastClosed" },
    detailPageLoadCount: { Text: "detailPageLoadCount", Value: "detailPageLoadCount" }
};

const CharterFlightType = {
    OneWay: 'One-Way',
    RoundTrip: 'Round Trip',
}

const SignalRConnectionStatus = {
    Connecting: 0,
    Connected: 1,
    Reconnecting: 2,
    Disconnected: 3,
}

export {
    inquiryType,
    bidderStatus,
    bidCallerCollectionTypes,
    contactType,
    phoneType,
    gtmEventType,
    hostedStoreGatewayTypes,
    categorySpecGroup,
    monthNames,
    monthShortNames,
    dayNames,
    dayShortNames,
    queryString,
    webListingeListingType,
    subscriptionChannelType,
    smsType,
    modalType,
    homePageCategoryGroup,
    eventCategory,
    userCreationType,
    magazineDistributionPublications,
    listingAlertSpecNamesToCheck,
    loanApprovalFields,
    achFields,
    consentCookieNames,
    cookieNames,
    bannerAdPositions,
    approvalAmountLocalStorageName,
    popupListDetailLoanApprovalEstimateModal,
    enableNewRegistrationPopUp,
    enableListDetailBanners,
    sandhillsCookieClassifications,
    topLevelClassificationsToSkipLowerClassifications,
    topLevelParentTrailerCategories,
    INT32_MAX_VALUE,
    SHORT_MAX_VALUE,
    webSavedSearchAuthenticatedLimit,
    webSavedSearchNameCharCountLimit,
    homePageCategoryTab,
    classificationConstants,
    rentalFacetOptions,
    leaseFacetOptions,
    customWatchlistLimit,
    maxImageCount,
    mfaDisplayModes,
    mfaMethodSource,
    daysToSnoozeCurrencyAlerts,
    invalidCurrencyPopUpBaseCatIDs,
    baseCatBlur,
    LinkRelationTypes,
    listResultsPerPageOptions,
    gridResultsPerPageOptions,
    defaultListPageSize,
    defaultNewListPageSize,
    registrationNotificationTypes,
    LoginPromptEvents,
    CharterFlightType,
    SignalRConnectionStatus,
    secondsLeftToAddListingToCountdown,
    secondsInAHour,
};